import queryString from 'query-string'

import { handleSsoLogin } from '../../containers/Auth'
import { CLEAR_STATE } from '../../constants'
// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'SsoLogin.'
export const EXAMPLE_ACTION_TYPE = `${PREFIX}EXAMPLE_ACTION_TYPE`

// ------------------------------------
// Actions
// ------------------------------------
export function exampleActionType() {
  return {
    type: EXAMPLE_ACTION_TYPE,
  }
}


export const handleSsoQuery = (match, location) => (dispatch, getState) => {
  const {
    teamId,
    ssoRoute,
  } = match.params
  const queryParams = queryString.parse(location.search)
  queryParams.ssoRoute = ssoRoute
  queryParams.team = teamId

  return dispatch(handleSsoLogin(queryParams))
}

const initialState = {
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [EXAMPLE_ACTION_TYPE]: (state, action) => ({ ...initialState }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function ssoLoginReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/SsoLogin/module.js